import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// see VDC: lazy load language messages for better performance
const loadedLanguages = []

export function loadLanguageAsync(lang) {

    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(i18n.locale = lang)
    }

    // if  language already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(i18n.locale = lang)
    }
    // if not loaded yet
    return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`).then(

    messages => {
        i18n.setLocaleMessage(lang, messages)
            loadedLanguages.push(lang)
            return i18n.locale = lang
        }
    )
}



const i18n = new VueI18n({
    fallbackLocale: 'de',
    silentTranslationWarn: true
})

export default i18n

